import React from 'react';
import frankStyles from 'components/frank/_style.module.scss';

// Without a percentage the bar sweeps: a wait with nothing to count (one answer) would otherwise show an invented
// figure.
const FrankProgressOverlay = ({ title, percentage }) => {
  const counted = percentage != null;

  return (
    <div className={frankStyles.pricingSettleOverlay}>
      <div className={frankStyles.pricingSettleCard}>
        <span className={frankStyles.pricingSettleText}>{title}</span>
        <div className={frankStyles.pricingSettleBar}>
          {counted
            ? <div className={frankStyles.pricingSettleFill} style={{ width: `${percentage}%` }} />
            : <div className={frankStyles.indeterminateFill} />}
        </div>
        {counted && <span className={frankStyles.pricingSettlePercent}>{percentage}%</span>}
      </div>
    </div>
  );
};

export default FrankProgressOverlay;
